import React from 'react';
import { Page, PageHeader, PageBody } from "../base/Page";
import { Button, Row, Col, Panel, FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import API from "../base/API";
import { browserHistory } from "react-router";
import Auth from "../auth/Auth";
import Switch from 'react-bootstrap-switch';
import { translate } from '../base/Translation';

export default class ErrorResultNew extends Auth {

    constructor(props) {
        super(props);

        this.api = new API({
            get_test: "/test/fetch/:test",
            get_errors: "/error/fetch/by/error_db/:error_db",
            get_error: "/error/fetch/:error",
            get_protocol: "/protocol/fetch/:protocol",
            save_result: "/error_result/save/new",
        });

        this.state = {
            test: null,
            error: null,
            protocol: null,
            errors: [],
            selected_group: "0",
            selected_error: "0",
            result: {
                id: 0,
                error: null,
                protocol: null,
                test: null,
                simulated: false,
                successful: false,
                note: "",
                state_after: "",
                state_before: "",
                required_state: "",
            }
        };
    }

    componentDidMount() {
        this.fetchData();
    }

    loadError(id) {
        this.api.request({
            route: "get_error",
            params: { error: id },
            success: (response) => {
                let result = this.state.result;
                result.error = response;
                this.setState({ error: response, result: result, selected_error: id });
            }
        });
    }

    fetchData() {
        this.api.request({
            route: "get_test",
            params: { test: this.props.params.test_ID },
            success: (response) => {
                let result = this.state.result;
                result.test = response;
                this.setState({ test: response, result: result });
            }
        });

        this.api.request({
            route: "get_protocol",
            params: { protocol: this.props.params.protocol_ID },
            success: (response) => {
                let result = this.state.result;
                result.protocol = response;

                this.api.request({
                    route: "get_errors",
                    params: { error_db: response.error_db },
                    success: (response) => {
                        this.setState({ errors: response });
                    }
                });


                this.setState({ protocol: response, result: result });
            }
        });
    }

    onSave(evt) {
        this.api.request({
            route: "save_result",
            data: this.state.result,
            created: (response) => {
                browserHistory.push("/tests/" + this.state.test.id + "#test_errordb");
            }
        });
    }

    onChange(evt) {
        let result = this.state.result;
        result[evt.target.name] = evt.target.value;
        this.setState({ result });
    }

    renderOptions(data) {
        let options = data.map(function (item) {
            return (
                <option value={item.id}
                    key={item.id}>{typeof item.name !== "undefined" ? item.name : item.email}</option>
            )
        });

        return (options);
    }

    handleSwitch(elem, state) {
        let result = this.state.result;
        result[elem.props.name] = state;
        this.setState({ result });
    }

    render() {

        if (this.state.errors === null || this.state.protocol === null || this.state.test === null || this.state.result === null) {
            return (
                <Page>
                    <PageHeader>{translate("Prosím počkajte")}</PageHeader>
                    <PageBody>{translate("Obsah sa načítava")}</PageBody>
                </Page>
            );
        }

        if (this.state.error === null) {
            let groups = [];

            for (let i = 0; i < this.state.errors.length; i++) {
                let err = this.state.errors[i];
                if (groups.indexOf(err.group) < 0) {
                    groups.push(err.group);
                }
            }


            return (
                <Page>
                    <PageHeader title={translate("Pridať chybu")} />
                    <PageBody>
                        <Row>
                            <Col lg={6}>
                                <Panel header={translate("Vyberte skupinu chýb a chybu")}>
                                    <FormGroup>
                                        <ControlLabel>{translate("Skupina chýb")}</ControlLabel>
                                        <select className="form-control" defaultValue={0} onChange={(e) => { if (e.target.value !== "0") { this.setState({ selected_group: e.target.value }) } }}>
                                            <option value="0" disabled>{translate("Vyberte")}</option>
                                            {groups.map(function (item) {
                                                return (
                                                    <option key={item} value={item}>{item}</option>
                                                )
                                            })}
                                        </select>
                                    </FormGroup>
                                    <FormGroup style={{ display: this.state.selected_group !== "0" ? "block" : "none" }}>
                                        <ControlLabel>{translate("Chyba")}</ControlLabel>
                                        <select className="form-control" defaultValue={0} onChange={(e) => { if (e.target.value !== "0") { this.loadError(e.target.value); } }}>
                                            <option value="0" disabled>{translate("Vyberte")}</option>
                                            {this.state.errors.map(function (item) {
                                                if (item.group !== this.state.selected_group) {
                                                    return;
                                                }

                                                return (
                                                    <option key={item.id} value={item.id}>{item.code + " - " + item.component}</option>
                                                )
                                            }.bind(this))}
                                        </select>
                                    </FormGroup>
                                </Panel>
                            </Col>
                        </Row>
                    </PageBody>
                </Page>
            );
        }

        let result = this.state.result;

        if (result.state_before === "") {
            result.state_before = this.state.error.state_before;
        }

        if (result.required_state === "") {
            result.required_state = this.state.error.required_state;
        }

        if (result !== this.state.result) {
            this.setState({ result });
        }


        return (
            <Page>
                <PageHeader title={translate("Pridať chybu")} />
                <PageBody>
                    <Row>
                        <Col lg={12}>
                            <Panel header={this.state.selected_group}>
                                <Row>
                                    <Col lg={6}>
                                        <FormGroup>
                                            <ControlLabel>{translate("Predmet kontroly")}</ControlLabel>
                                            <FormControl disabled defaultValue={this.state.error.component + " (" + this.state.error.code + ")"} />
                                        </FormGroup>

                                        <FormGroup>
                                            <ControlLabel>{translate("Požadovaný stav")}</ControlLabel>
                                            <FormControl name="required_state" defaultValue={this.state.result.required_state} onChange={this.onChange.bind(this)} />
                                        </FormGroup>

                                        <Row>
                                            <Col md={9} sm={12}>
                                                <FormGroup>
                                                    <ControlLabel>{translate("Stav pred testom")}</ControlLabel>
                                                    <FormControl value={this.state.result.state_before} name="state_before" onChange={this.onChange.bind(this)} />
                                                </FormGroup>
                                            </Col>
                                            <Col md={3} sm={12}>
                                                <FormGroup>
                                                    <ControlLabel>{translate("Simulované")}</ControlLabel>
                                                    <Switch value={this.state.result.simulated} onText={translate("Áno")} offText={translate("Nie")} onChange={(el, state) => this.handleSwitch(el, state)} name='simulated' />
                                                </FormGroup>
                                            </Col>
                                        </Row>


                                        <Row>
                                            <Col md={9} sm={12}>
                                                <FormGroup>
                                                    <ControlLabel>Stav po teste</ControlLabel>
                                                    <FormControl value={this.state.result.state_after ? this.state.result.state_after : ""} name="state_after" onChange={this.onChange.bind(this)} />
                                                    <div className="input_note">Požadovaný stav
                                                <span className="highlight clickable" onClick={() => {
                                                            let result = this.state.result;
                                                            result.state_after = this.state.result.required_state;
                                                            this.setState({ result });
                                                        }}>{this.state.result.required_state}</span>
                                                    </div>
                                                </FormGroup>
                                            </Col>
                                            <Col md={3} sm={12}>
                                                <FormGroup>
                                                    <ControlLabel>{translate("Vyhovel")}</ControlLabel>
                                                    <Switch value={this.state.result.successful} onText={translate("Áno")} offText={translate("Nie")} onChange={(el, state) => this.handleSwitch(el, state)} name='successful' />
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                        <FormGroup>
                                            <ControlLabel>{translate("Poznámka")}</ControlLabel>
                                            <FormControl componentClass="textarea" value={this.state.result.note} name="note" onChange={this.onChange.bind(this)} />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </Panel>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12}>
                            <FormGroup>
                                <Button bsStyle="success" onClick={this.onSave.bind(this)}>{translate("Uložiť")}</Button>
                            </FormGroup>
                        </Col>
                    </Row>
                </PageBody>
            </Page>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/error/ErrorResultNew.js